module.exports = __webpack_public_path__ + "img/item12.7342065c.png";